export default class TagExportCtrl {
    constructor($filter, $state, $stateParams, $location, SideMenu, Tag, Customization, Events, Event, CurrentAccount, SweetAlert) {
        SideMenu.setActive('tag');

        this.tagRepo = Tag;
        this.eventRepo = Event;
        this.customizationRepo = Customization;
        this.eventHandler = Events;

        this.sweetAlert = SweetAlert;
        this._stateParams = $stateParams;
        this._state = $state;
        this._filter = $filter;
        this.currentAccount = CurrentAccount;

        this.tagId = this._stateParams.tagId ? this._stateParams.tagId : this._stateParams.id;
        this.isEventExport = this._stateParams.tagId != null;

        if (this.isEventExport) {
            this.useEventData = false;
            this.useSurveyData = false;
            let eventId = this._stateParams.id;

            this.eventRepo.findCustomGroup(eventId).then((customGroups) => {
                angular.forEach(customGroups.data, (group) => {
                    if (group.name == 'Event' + eventId) {
                        this.customEventData = group;
                        this.useEventData = true;
                    } else if (group.name == 'Survey' + eventId) {
                        this.customSurveyData = group;
                        this.useSurveyData = true;
                    }
                });
            });
        }

        this.toFile = true;
        this.includeAll = [];
        this.groupSettings = [];

        this.exportActive = true;
        this.exportSuppressed = true;

        this.exportWrapper = {
            toFile: true,
            toTagsIds: []
        };

        this.customizationRepo.allGroups().then((customData) => {
            this.customGroups = customData.data;

            angular.forEach(this.customGroups, (group, index) => {
                this.groupSettings[index] = { maximized: false, includeAll: false };
            });
        });

        this.tagRepo.find(this.tagId).then((tag) => {
            this.tag = tag.data;
        });
    }

    toggleEventData() {
        this.useEventData = ! this.useEventData;
    };

    toggleSurveyData() {
        this.useSurveyData = ! this.useSurveyData;
    };

    export() {
        if (!(this.exportActive || this.exportSuppressed)) {
            this.sweetAlert.swal({
                title: this._filter('translate')('GLOBAL:FLASH:OOPS'),
                text: this._filter('translate')('SEGMENTATION:FLASH:INVALID_BUNCH'),
                type: "warning"
            });

            return;
        }

        var exportWrapper = {};
        var exportFields = [
            { name: 'email' },
            { name: 'phone_number' },
            { name: 'language' },
            { name: 'created_at' }
        ];

        if (this.isEventExport) { // Include event data.
            if (this.useEventData) {
                angular.forEach(this.customEventData.fields, (field) => {
                    exportFields.push({
                        id: field.id,
                        name: field.name,
                        type: field.type
                    });
                });
            }

            if (this.useSurveyData) {
                angular.forEach(this.customSurveyData.fields, (field) => {
                    exportFields.push({
                        id: field.id,
                        name: field.name,
                        type: field.type
                    });
                });
            }
        }

        exportWrapper.exportActive = this.exportActive;
        exportWrapper.exportSuppressed = this.exportSuppressed;

        if (this.exportSuppressed) {
            exportFields = exportFields.concat(
                [
                    { name: 'suppressed_source'},
                    { name: 'suppressed_email_campaign'},
                    { name: 'suppressed_email_transactional'},
                    { name: 'suppressed_sms_campaign'},
                    { name: 'suppressed_sms_transactional'}
                ]
            );
        }

        angular.forEach(this.customGroups, (group) => {
            angular.forEach(group.fields, (field) => {
                if (field.include) {
                    exportFields.push({
                        id: field.id,
                        name: field.name,
                        type: field.type
                    });
                }
            });
        });

        exportWrapper.fields = exportFields;
        exportWrapper.tagId = this.tag.id;
        exportWrapper.toTagsIds = this.exportWrapper.toTagsIds;

        if (! this.exportWrapper.toFile) {
            this.tagRepo.exportToTag(exportWrapper).then((response) => {
                this.eventHandler.flashEvent('notification', this._filter('translate')('TAG:EXPORT:EXPORT_TAG_STARTED'));
                this.isEventExport
                    ? this._state.go('event.show', { id: this._stateParams.id, eventSubscribersStatus: this._stateParams.eventSubscribersStatus, exportId: response.data.id, isFileExport: false })
                    : this._state.go('tag.show', { id: this.tagId, exportId: response.data.id, isFileExport: false });
            });
        } else {
            this.tagRepo.exportToFile(exportWrapper).then((response) => {
                this.eventHandler.flashEvent('notification', this._filter('translate')('TAG:EXPORT:EXPORT_STARTED'));
                this.isEventExport
                    ? this._state.go('event.show', { id: this._stateParams.id, eventSubscribersStatus: this._stateParams.eventSubscribersStatus, exportId: response.data.id, isFileExport: true })
                    : this._state.go('tag.show', { id: this._stateParams.id, exportId: response.data.id, isFileExport: true });
            });
        }
    };

    toggleGroup(event, groupId) {
        event.stopPropagation();
        var state = this.groupSettings[groupId].includeAll;

        angular.forEach(this.customGroups[groupId].fields.data, (field) => {
            field.include = state;
        });
    };

    toggleSize(groupIndex) {
        this.groupSettings[groupIndex].maximized = ! this.groupSettings[groupIndex].maximized;
    };

    ready() {
        if (! this.exportWrapper.toFile) {
            return this.exportWrapper.toTagsIds.length > 0;
        } else {
            return true;
        }
    };
};
